export default {
  field: {
    label: 'Tax category',
    placeholder: 'No tax category',
    unlinked_hint: "Without one, a product uses its menu category's tax category, or the restaurant's standard rate.",
    default_hint: "Saved without one, it gets the menu's default tax category.",
  },
  empty: {
    hint: 'No tax categories yet — add one below.',
    read_only_hint: 'No tax categories have been set up yet.',
  },
  option: {
    varies_by_channel: '(varies by channel)',
  },
  load_error: 'Could not load tax categories — linking and unlinking are disabled until this loads.',
  create: {
    name_placeholder: 'New category name',
    rate_placeholder: 'Rate %',
    button: 'Add tax category',
  },
  toasts: {
    create_error: 'Could not create the tax category.',
  },
};
